import * as React from 'react'

export const SvgOrderOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M17.618 4L20 8.764V21H4V8.764L6.382 4h11.236zm.381 6H6v9h12v-9zm-7-4H7.618L6.616 8H11V6zm5.382 0h-3.382v2h4.381l-.999-2z" />
  </svg>
)
export default SvgOrderOutline
